export default function getResource(label, vars = []) {
    const resources = {
        bookAnAppointment: 'Prendre rendez-vous',
        yourService: 'Votre service',
        reviewAndPay: 'Review & Pay',
        confirmAppointmentDetails: 'Confirm Appointment Details',
        free: 'GRATUIT'
    };

    return resources[label];
}
